import React from 'react';

import UserLootboxesList from './UserLootboxesList';
import UserLootboxesMetrics from './UserLootboxesMetrics';

function UserLootboxesPage() {
    return (
        <>
            <UserLootboxesMetrics url="/crea/api/metrics" />
            <UserLootboxesList />
        </>
    );
}

export default UserLootboxesPage;
